import { render, staticRenderFns } from "./CompetitionDashboard.html?vue&type=template&id=75c34764&"
import script from "./CompetitionDashboard.js?vue&type=script&lang=js&"
export * from "./CompetitionDashboard.js?vue&type=script&lang=js&"
import style0 from "./CompetitionDashboard.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports